var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLotus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.0739 19.8506H43.0554C34.9304 19.8506 27.9519 24.4248 24.9999 31.4935C22.0478 24.4248 15.0693 19.8506 6.9443 19.8506L0.925781 19.8506V24.3645C0.925781 35.1497 9.70078 43.5185 20.486 43.5185H24.9999H29.5137C40.2989 43.5185 49.0739 35.1497 49.0739 24.3645V19.8506Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.0001 27.4455C27.567 24.015 31.0487 21.418 35.0119 19.9073C33.089 8.60758 25.0001 2.69531 25.0001 2.69531C25.0001 2.69531 16.9112 8.60758 14.9883 19.9043C18.9515 21.418 22.4332 24.015 25.0001 27.4455Z",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.88448 12.8994C5.88448 12.8994 8.79444 12.8543 10.3201 13.1071C11.8458 13.3598 13.3354 13.8172 14.7588 14.4311C14.2623 15.8966 13.8289 17.4705 13.516 19.2128C11.8458 18.8246 10.1305 18.5628 8.3611 18.5628H5.85439C5.54444 17.1816 5.4917 17.1875 5.4917 15.7641C5.4917 14.3407 5.88448 12.8994 5.88448 12.8994Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.9954 12.8994C43.9954 12.8994 41.0854 12.8543 39.5598 13.1071C38.0341 13.3598 36.5445 13.8172 35.1211 14.4311C35.6176 15.8966 36.051 17.4705 36.3639 19.2128C38.0341 18.8246 39.7493 18.5628 41.5188 18.5628H44.0255C44.3354 17.1816 44.3882 17.1875 44.3882 15.7641C44.3882 14.3407 43.9954 12.8994 43.9954 12.8994Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.704,
    height: 3.704,
    x: 23.148,
    y: 45.37,
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotus);
export default __webpack_public_path__ + "static/media/lotus.10910cab6ece0e0db3d9e7be19a7959f.svg";
export { ForwardRef as ReactComponent };